import { render, staticRenderFns } from "./ProductivityChart.vue?vue&type=template&id=a2c98e5c&"
import script from "./ProductivityChart.vue?vue&type=script&lang=js&"
export * from "./ProductivityChart.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ProductivityChart.vue?vue&type=style&index=0&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports